/** In-memory catalog cache so back-from-product does not re-download everything. */

let cache = null;
let inflight = null;
const TTL_MS = 5 * 60 * 1000;
let cachedAt = 0;

function normalizeName(name = '') {
  return name.toLowerCase().trim().replace(/\s+/g, ' ');
}

export function hasCatalogCache() {
  return Boolean(cache && Date.now() - cachedAt < TTL_MS);
}

export function clearCatalogCache() {
  cache = null;
  cachedAt = 0;
  inflight = null;
}

export async function getCatalog() {
  if (hasCatalogCache()) return cache;
  if (inflight) return inflight;

  inflight = Promise.all([
    fetch('/api/products').then((res) => res.json()),
    fetch('/api/services').then((res) => res.json()),
    fetch('/api/brand-products').then((res) => res.json()).catch(() => []),
    fetch('/api/categories').then((res) => res.json()).catch(() => []),
    fetch('/api/brands').then((res) => res.json()).catch(() => []),
    fetch('/api/related-products').then((res) => res.json()).catch(() => []),
  ])
    .then(([productsData, servicesData, brandProductsData, categoriesData, brandsData, relatedProductsData]) => {
      const brandByProductName = new Map(
        (brandProductsData || []).map((brandProduct) => [
          normalizeName(brandProduct.name),
          brandProduct.brand,
        ])
      );

      const products = [
        ...(productsData || []).map((product) => ({
          ...product,
          brand: product.brand || brandByProductName.get(normalizeName(product.name)),
        })),
        ...(servicesData || []).map((s) => ({
          ...s,
          rating: s.rating || 5.0,
          reviewsCount: s.reviewsCount || 0,
          isService: true,
        })),
        ...(brandProductsData || []).map((product) => ({ ...product, isBrandProduct: true })),
        ...(relatedProductsData || []),
      ];

      cache = {
        products,
        categories: categoriesData || [],
        brands: brandsData || [],
        services: servicesData || [],
      };
      cachedAt = Date.now();
      return cache;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
}
